




























































module.exports =
  name: 'period_totals'
  props: ['transactions', 'months_count']
  components:
    balance: require('components/inside/elements/balance.vue').default
  computed:
    net_sum:          -> @transactions.incomes.sum + @transactions.expenses.sum
    net_percentage:   ->
      return '' if @transactions.incomes.sum == 0 || @transactions.expenses.sum == 0
      Math.round(@net_sum / @transactions.incomes.sum * 100)
    incomes_average:  -> @transactions.incomes.sum / @months_count
    expenses_average: -> @transactions.expenses.sum / @months_count
    net_average:      -> @incomes_average + @expenses_average

